<template>
	<section class="app-user user-watches">
		<div class="header">
			<div class="title">
				<router-link class="nav-link back-icon" :to="{ name: 'Support', params: { user_uid: selectedAccount } }">
					<svgicon name="back" class="svgicon":fill="true"></svgicon>
				</router-link>
				<h1>{{ $t('base.general.ticket') }} Nº{{ tickect.id }} - {{ tickect.state }}</h1>
			</div>

			<div class="btn-group">
				<button-native-icon-text
					icon="plus-w"
					class="plus btn-add"
					@click.native="onModalBoxOpen()">
					{{ $t('base.general.response') }}
				</button-native-icon-text>

				<button-native-icon-text
					icon="check"
					class="plus btn-delete"
					@click.native="actionTicketClose()">
					{{ $t('base.general.close_ticket') }}
				</button-native-icon-text>
			</div>

		</div>
		<table class="ticket-table">
			<tr class="ticket-table__item">
				<td class="ticket-table__column">{{ $t('base.general.responses') }}</td>
				<td class="ticket-table__column">{{ tickect.response.length }}</td>
			</tr>
			<tr class="ticket-table__item">
				<td class="ticket-table__column">{{ $t('labels.general.subject') }}</td>
				<td class="ticket-table__column">{{ tickect.subject }}</td>
			</tr>
			<tr class="ticket-table__item">
				<td class="ticket-table__column">{{ $t('labels.general.message') }}</td>
				<td class="ticket-table__column">{{ tickect.message }}</td>
			</tr>
			<tr class="ticket-table__item">
				<td class="ticket-table__column">{{ $t('labels.general.created') }}</td>
				<td class="ticket-table__column">{{ tickect.created }}</td>
			</tr>
			<tr class="ticket-table__item">
				<td class="ticket-table__column">{{ $t('labels.general.state') }}</td>
				<td class="ticket-table__column">{{ tickect.state }}</td>
			</tr>
		</table>
		<div class="subheader">
			<h1>{{ $t('base.general.responses') }}</h1>
		</div>
		<div v-for="model in tickect.response" :key="model.id">
			<div class="response-table">
				<div class="response-table__item">
					<div class="response__column">{{ model.created }}</div>
					<div class="response__column">{{ model.owner }}</div>
					<div class="response__column">{{ model.message }}</div>
				</div>
			</div>
		</div>

		<modal-box v-if="modalBox.open" @close="onModalBoxClose" :header="$t('base.general.response')" :subHeader="$t('base.general.ticket')">
			<responde-form-component @completed="onFormCompleted"></responde-form-component>
		</modal-box>
	</section>
</template>

<script>
	import RespondeFormComponent from './forms/RespondeFormComponent'
	export default {
		name: 'ticket-component',
		components: {
			RespondeFormComponent
		},
		props: [
			'user_uid'
		],
		data () {

			return {
				modalBox: {
					open: false,
				},
				tickect: {
					id: 1,
					subject: 'O relógio não conecta',
					message: 'Após ligar o relógio e colocá-lo no pulso, tentei conectá-lo à plataforma, mas sem efeito.',
					state: 'Open',
					created: '2020-01-20 14:54',
					response: [
						{ id: 1, created: '2020-01-29 18:54', owner: 'Pedro Silva', message: 'Verifique se o relógio está ligado à rede e está a transmitir dados.'},
						{ id: 2, created: '2020-01-27 15:24', owner: 'Idicare', message: 'Verifique se introduziu conrretamente o número de IMEI.'},
						{ id: 3, created: '2020-01-27 11:56', owner: 'Pedro Silva', message: 'Dispositivos tem de pretencer um grupo. Caso contrário deve criar um grupo primeiro.'},
						{ id: 4, created: '2020-01-22 16:11', owner: 'Pedro Silva', message: 'Todos os campos devem ser preenchidos, e de preferência o nome do dispositivo deve ser igual ao seu IMEI.'},
						{ id: 6, created: '2020-01-20 10:13', owner: 'Pedro Silva', message: 'Deve encontrar o botão de switch(Patcientes/Dispositivos) e selecionar Dispositivos. E aí encontrará o botão "Adicionar dispositivo".'},
						{ id: 7, created: '2020-01-20 9:54', owner: 'Pedro Silva', message: 'Na paltaforma, na área de Pacientes, deve clicar em "Adicionar dispositivo".'}
					]
				}
			}
		},
		methods: {
			onModalBoxClose(){
				this.modalBox.open = false
			},
			onModalBoxOpen(){
				this.modalBox.open = true
			},
			actionTicketClose() {
				alert('action to close ticket')
			},
			onFormCompleted() {
				this.modalBox.open = false
			}
		},
		computed: {
			selectedAccount () {
				return this.$store.state.user.selectedAccount
			}
		}

	}
</script>

<style scope>
	.header:not(.large) {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid var(--main-color);
		min-height: 44px;
	}
	.app-watch > .header {
		display: block;
		border-bottom: 0;
		min-height: unset;
	}
	.header h1{
		border-bottom: 0;
		font-size: 1.5em;
		margin: 0;
	}
	.subheader {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid var(--main-color);
		min-height: 44px;
		margin-top: 80px;
	}
	.subheader h1{
		border-bottom: 0;
		font-size: 1.3em;
		margin: 0;
	}
	.ticket-table {
		width: 100%;
	}
	.ticket-table__item {
		display: flex;
		align-items: right;
	}
	.ticket-table__column {
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		align-items: self-start;
		text-align: left;
		font-family: var(--font-bold);
		color: #888;
		padding: 10px;
	}
	.ticket-table .ticket-table__item .ticket-table__column:first-of-type {
		min-width: 220px;
		max-width: 220px;
	}
	.response-table__item {
		display: grid;
		grid-template-columns: 1fr 1fr 8fr;
		margin: 20px 0;
		padding: 20px 0;
		border-bottom: 1px solid #ccc;
	}
	.response-table__item .response__column:first-of-type{
		font-weight: 800;
	}
	.title {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.back-icon {
		margin-right: 10px;
		text-decoration: none;
	}
	.svgicon {
		fill: #00A2AC;
		width: 18px;
		height: 18px;
	}

	@media screen and (max-width: 1025px) {
		.btn.btn-delete {
			background-color: transparent;
		}
		.header:not(.large) {
			margin: 0 10px;
		}
		.app-watch > .header {
			margin: 0;
		}
		.subheader {
			margin-left: 10px;
			margin-right: 10px;
		}
		.response-table {
			margin-left: 10px;
			margin-right: 10px;
			font-size: 12px;
		}
		.ticket-table .ticket-table__item .ticket-table__column:first-of-type {
			min-width: 170px;
			max-width: 170px;
		}
		.btn.btn-add {
			margin-right: 0px;
		}
		.sk__content {
			overflow: auto;
		}
	}
	@media screen and (max-width: 600px) {
		.ticket-table .ticket-table__item .ticket-table__column:first-of-type {
			min-width: 120px;
			max-width: 120px;
		}
		.response-table {
			font-size: 10px;
		}
		.ticket-table {
			font-size: 12px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/support/TicketComponent.vue